/**
 * The "SAA — " / "CAA — " prefix some areas carry in their stored name. A type
 * chip sits beside every heading that uses this, so repeating the kind of area
 * in the name spends the most prominent line on something already stated.
 *
 * Display-only: the stored name is untouched, the detail page's breadcrumb keeps
 * it in full, and a name that is nothing BUT the prefix falls back to itself
 * rather than rendering an empty heading.
 *
 * Shared by the list card and the detail page it opens, so clicking a card can't
 * appear to rename the area.
 */
const AREA_TYPE_PREFIX = /^(SAA|CAA)\s*[—–-]\s*/i;

export function displayAreaName(name: string): string {
  return name.replace(AREA_TYPE_PREFIX, "").trim() || name;
}
